export default __webpack_public_path__ + "static/media/clinician_mobile.03dc3f0c.jpg";